<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [variante]="variante"
  [(ngModel)]="idsCanaisVendas"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
</sgt-multi-select>
